import { gql } from '@apollo/client';

export interface AIInterviewRequest {
    id: string;
    jobId: string;
    createdAt: number;
    interviewUrl: string;
    interviewTime: number | null;
    interviewTranscriptFile: string;
    interviewRecordingFile: string | null;
    requestId: string;
}

export interface AIInterviewRequestsVariables {
    where: { personId: { _eq: string } };
}

export const AI_INTERVIEW_REQUESTS = gql`
    query AIInterviewRequests($where: ai_interview_requests_bool_exp!) {
        interviewRequests: ai_interview_requests(
            where: $where
            order_by: [{ interviewTime: desc_nulls_last }, { createdAt: desc }]
            limit: null
            offset: 0
        ) {
            id
            jobId
            createdAt
            interviewUrl
            interviewTime
            interviewTranscriptFile
            interviewRecordingFile
            requestId
        }
    }
`;

export const CREATE_AI_INTERVIEW_REQUEST = gql`
    mutation CreateAIInterviewRequest($personId: String!, $jobId: String!) {
        createAIInterviewRequest(personId: $personId, jobId: $jobId)
    }
`;
